import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import {
  ConversionEligibility,
  CtpSliceType,
  BillingAccountInfo,
  ISubscriptionInfo,
  IAvaliableOffer,
} from './types';

const initialState: CtpSliceType = {
  isExpiryNoticeModalClosed: false,
  isFinishAccountSetupModalClosed: false,
  isFinishAccountSetupBannerClosed: false,
  isAvailableOffersFetched: false,
  availableOffers: [],
  availableCtpPlan: null,
  conversionEligibility: null,
  billingAccountInfo: null,
  subscriptionInfo: null,
};

const ctpSlice = createAppSlice({
  name: 'ctp',
  initialState,
  reducers: {
    setIsExpiryNoticeModalClosed(state, action: PayloadAction<boolean>) {
      state.isExpiryNoticeModalClosed = action.payload;
    },
    setIsFinishAccountSetupModalClosed(state, action: PayloadAction<boolean>) {
      state.isFinishAccountSetupModalClosed = action.payload;
    },
    setIsFinishAccountSetupBannerClosed(state, action: PayloadAction<boolean>) {
      state.isFinishAccountSetupBannerClosed = action.payload;
    },
    setIsAvailableOffersFetched(state, action: PayloadAction<boolean>) {
      state.isAvailableOffersFetched = action.payload;
    },
    setAvailableOffers(state, action: PayloadAction<IAvaliableOffer[]>) {
      state.availableOffers = action.payload;
    },
    setAvailableCtpPlan(
      state,
      action: PayloadAction<CtpSliceType['availableCtpPlan']>,
    ) {
      state.availableCtpPlan = action.payload;
    },
    setConversionEligibility(
      state,
      action: PayloadAction<ConversionEligibility>,
    ) {
      state.conversionEligibility = action.payload;
    },
    setBillingAccountInfo(state, action: PayloadAction<BillingAccountInfo>) {
      state.billingAccountInfo = action.payload;
    },
    setSubscriptionInfo(state, action: PayloadAction<ISubscriptionInfo>) {
      state.subscriptionInfo = action.payload;
    },
  },
});

export const {
  setIsExpiryNoticeModalClosed,
  setIsFinishAccountSetupModalClosed,
  setIsFinishAccountSetupBannerClosed,
  setIsAvailableOffersFetched,
  setAvailableOffers,
  setAvailableCtpPlan,
  setConversionEligibility,
  setBillingAccountInfo,
  setSubscriptionInfo,
} = ctpSlice.actions;
export default ctpSlice.reducer;
